module.exports = __webpack_public_path__ + "static/img/home-joinus-appqr.4ae3a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-joinus-appqr.png
// module id = NEii
// module chunks = 0